import { ref, computed, type Ref } from 'vue'

export function usePagination<T>(items: Ref<T[]>, itemsPerPage: Ref<number>) {
    const currentPage = ref<number>(1)

    const totalPages = computed(() =>
        Math.ceil(items.value.length / itemsPerPage.value)
    )

    const paginatedItems = computed(() => {
        const start = (currentPage.value - 1) * itemsPerPage.value
        return items.value.slice(start, start + itemsPerPage.value)
    })

    const canGoPrev = computed(() => currentPage.value > 1)
    const canGoNext = computed(() => currentPage.value < totalPages.value)

    const nextPage = () => canGoNext.value && currentPage.value++
    const prevPage = () => canGoPrev.value && currentPage.value--

    return {
        currentPage,
        totalPages,
        paginatedItems,
        canGoPrev,
        canGoNext,
        nextPage,
        prevPage
    }
}

